import { H2, H5 } from "../../../../AbstractElements";
import { FormGroup, Input, Label } from "reactstrap";
import { ConfirmPasswordWizard, ConfirmPasswordWizardPlaceholder, EmailAddressWizard, EmailAddressWizardPlaceholder, EnterYourEmailPasswordToLoginWizard, PasswordWizard, PasswordWizardPlaceholder, SignUpToAccount } from "../../../../Constant";
import { RegisterWizardForm } from "../../../../Type/Pages";

const AddressForm = ({ formValue, getUserData }: RegisterWizardForm) => {
  const { email, password, confirmPassword } = formValue;

  return (
    <div id="step-2" className="content">
      <div className="wizard-title">
        <H2>{SignUpToAccount}</H2>
        <H5 className="text-muted mb-4">{EnterYourEmailPasswordToLoginWizard}</H5>
      </div>
      <div className="login-main">
        <div className="theme-form">
          <FormGroup className="form-group mb-3 m-t-15">
            <Label htmlFor="exampleFormControlInput1" check>{EmailAddressWizard}</Label>
            <Input onChange={getUserData} value={email} name="email" id="exampleFormControlInput1" type="email" placeholder={EmailAddressWizardPlaceholder} />
          </FormGroup>
          <div className="form-group mb-3">
            <Label htmlFor="exampleInputPassword1" check>{PasswordWizard}</Label>
            <Input onChange={getUserData} value={password} name="password" id="exampleInputPassword1" type="password" autoComplete="" placeholder={PasswordWizardPlaceholder} />
          </div>
          <FormGroup className="mb-3">
            <Label htmlFor="exampleInputPassword1" check>{ConfirmPasswordWizard}</Label>
            <Input onChange={getUserData} value={confirmPassword} name="confirmPassword" id="exampleInputcPassword1" type="password" autoComplete="" placeholder={ConfirmPasswordWizardPlaceholder} />
          </FormGroup>
        </div>
      </div>
    </div>
  );
};

export default AddressForm;
